(function () {
  function shipDate() {
    var els = document.querySelectorAll('[data-mtn-ship]');
    if (!els.length) return;
    var d = new Date();
    var add = d.getUTCHours() >= 22 ? 2 : 1;
    while (add > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) add--; }
    var t = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
    els.forEach(function (e) { e.textContent = t; });
  }
  function build(col, imgs, title) {
    if (!imgs || imgs.length < 2) return;
    var g = document.createElement('div');
    g.className = 'mtn-pgrid';
    imgs.forEach(function (src) {
      var a = document.createElement('div');
      a.className = 'mtn-pgrid__item';
      a.style.backgroundImage = 'url(' + src + ')';
      a.setAttribute('role', 'img');
      a.setAttribute('aria-label', title || '');
      g.appendChild(a);
    });
    col.appendChild(g);
    document.documentElement.classList.add('mtn-has-pgrid');
  }
  function grid() {
    if (window.innerWidth < 769) return;
    var sec = document.querySelector('.product-section[data-section-type="product"]');
    if (!sec || sec.getAttribute('data-modal') === 'true') return;
    var col = sec.querySelector('.product-single__sticky');
    if (!col || col.querySelector('.mtn-pgrid')) return;
    var data = sec.querySelector('[data-mtn-media]') || document.querySelector('[data-mtn-media]');
    if (data) {
      try { build(col, JSON.parse(data.textContent), sec.getAttribute('data-product-title')); return; } catch (e) {}
    }
    var url = (sec.getAttribute('data-product-url') || '').split('?')[0];
    if (!url) return;
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var imgs = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src + (m.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'; });
      build(col, imgs, p.title);
    }).catch(function () {});
  }
  function init() { shipDate(); grid(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
